// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Checkbox_checkboxWrapper__9AWyw","checkbox":"Checkbox_checkbox__MjG28","isCircle":"Checkbox_isCircle__hy3t2"};